import angular from 'angular';
angular.module('commonServices').filter('nullDate', [
  function() {
    return function(date) {
      if (date === '0001-01-01T00:00:00Z' || date === '0001-01-01T00:00:00' || date === '')
        return null;
      return date;
    };
  },
]);
